import { FC } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StudentsTable } from '../students-table/students-table.component';
import { useGetFamilyQuery } from '../../../../store/api/families.api';

interface StudentsListProps {
	familyId?: string;
}

export const StudentsListComponent: FC<StudentsListProps> = (props) => {
	const { familyId } = props;

	const { data: family, isFetching } = useGetFamilyQuery({ id: familyId }, { skip: !familyId });

	const [t] = useTranslation();

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', height: '100%' }}>
			<Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 500 }}>
				{'Family Students'}
			</Typography>

			<StudentsTable data={family?.children ?? []} loading={isFetching} />
		</Box>
	);
};
